var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('home-hero',{attrs:{"headline":"Project so far","text":""}}),_c('v-container',[_c('h1')]),_c('home-projects'),_c('home-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }